import React            from 'react';
import { Observe }           from 'rewire-core';
import { Modal }             from 'rewire-ui';
import { Theme, makeStyles } from '../utility/styles';
import Button                from '@material-ui/core/Button';
import Icon                  from '@material-ui/core/Icon';
import classNames            from 'classnames';

const buttonStyle = (_theme: Theme) => ({
  root: {
  },
  button: {
  },
});

export const useButtonStyle = makeStyles(buttonStyle);

export default React.memo(({ modal, actions, classes }: { modal: Modal, actions: string[], classes?: any }) => {
  const buttonClasses = useButtonStyle({classes});

  return (
    <div className={classNames(buttonClasses.root, 'content')}>
      {actions.map((a) => {
        const action = modal.actions[a];
        if (!action) return null;

        return (
          <Observe key={a} render={() =>
            <Button className={classNames(buttonClasses.button, 'span1')} variant='contained' color={action.color} disabled={action.disabled()} onClick={action.action}>
              {action.icon && <Icon className={action.icon} style={{ marginRight: '8px' }}>{action.icon}</Icon>}
              <span className={a}>{a}</span>
            </Button>
          } />
        );
      })}
    </div>
  );
});
